import React from 'react';
import '../styles/Articles.css';

const stripHtml = (html) => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

const Article = ({ title, path, htmlTitle, content, media }) => {
  const cleanTitle = title.replace(/-/g, ' ').trim();
  const shortContent = stripHtml(content).slice(0, 100) + '...';
  const mediaUrl = media ? Object.values(media)[0] : null;

  return (
    <div className="article-card" style={{padding: 20}}>
      {mediaUrl && <img src={mediaUrl} alt={cleanTitle}className="article-blog-image" />}
      <h2>{cleanTitle}</h2>
      <p className="article-preview">{shortContent}</p>
      <a href={path}>Lire l'article</a>
    </div>
  );
};

export default Article;
